import React, { useEffect, useState } from 'react';
import { axios } from '~/library/utils/src';
import useMfeModule from '../../../../hooks/use-mfe-module';

function mfeCacheBuster() {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;
  return `${date.getDate()}${date.getHours()}${nearestQuarterHour}`;
}

export const ChatUi = () => {
  const mfeModule = useMfeModule(
    `${
      process.env.CHAT_BASE_URL
    }/build/assets-manifest.json?v=${mfeCacheBuster()}`,
    'main.js',
    'CarvanaChatUiModule'
  );

  return mfeModule && <mfeModule.default />;
};
